export enum OverviewAssetCategory {
  EvLoad = 'EV_LOAD',
  BaseLoad = 'BASE_LOAD',
  Pv = 'PV',
  GridLoad = 'GRID_LOAD',
  Battery = 'BATTERY',
}

export enum EvType {
  Van = 'VAN',
  Bus = 'BUS',
  Mixed = 'MIXED',
}

export enum SiteType {
  Fleet = 'FLEET',
  Public = 'PUBLIC',
}

export enum InfrastructureOverviewMicrogridControllerStatus {
  NotApplicable = 'NOT_APPLICABLE',
  Online = 'ONLINE',
  Offline = 'OFFLINE',
}

export enum VehicleOperationalStatus {
  Ready = 'READY',
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Faulted = 'FAULTED',
  InDepot = 'IN_DEPOT',
  OnTheRoad = 'ON_THE_ROAD',
  Unknown = 'UNKNOWN',
}

export enum VehicleEvseCombinedState {
  Available = 'AVAILABLE',
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Ready = 'READY',
  Faulted = 'FAULTED',
  FaultedUnplugRequired = 'FAULTED_UNPLUG_REQUIRED',
  Maintenance = 'MAINTENANCE',
}

export enum BessOperationalState {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
}

export enum EvseOperationalState {
  Available = 'AVAILABLE',
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Faulted = 'FAULTED',
  FaultedUnplugRequired = 'FAULTED_UNPLUG_REQUIRED',
  Maintenance = 'MAINTENANCE',
}

export enum EvseStatus {
  Charging = 'CHARGING',
  Queued = 'QUEUED',
  Available = 'AVAILABLE',
  Faulted = 'FAULTED',
  Maintenance = 'MAINTENANCE',
  Unknown = 'UNKNOWN',
}

export enum TimelineEntryType { // TODO Not needed right now
  PowerLimitChanged = 'POWER_LIMIT_CHANGED',
  VehiclePluggedIn = 'VEHICLE_PLUGGED_IN',
}

export enum HealthGrade {
  Good = 'GOOD',
  Warning = 'WARNING',
  Error = 'ERROR',
}

export enum VehicleDetailsWarning { // TODO Not needed right now
  LateArrival = 'LATE_ARRIVAL',
  PluginAsap = 'PLUGIN_ASAP',
}

export enum VehicleDetailsAlert { // TODO Not needed right now
  ChargerNotRamping = 'CHARGER_NOT_RAMPING',
  ContactorError = 'CONTACTOR_ERROR',
  PluginOverdue = 'PLUGIN_OVERDUE',
}

export enum Weekday {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
}

export enum ConnectorType {
  CCS2 = 'CCS2',
  TYPE_2 = 'TYPE_2',
  CHADEMO = 'CHADEMO',
  NACS = 'NACS',
  MCS = 'MCS',
}

export enum OcppChargePointStatus {
  Available = 'AVAILABLE',
  Occupied = 'OCCUPIED',
  Preparing = 'PREPARING',
  Charging = 'CHARGING',
  SuspendedEvse = 'SUSPENDED_EVSE',
  SuspendedEv = 'SUSPENDED_EV',
  Finishing = 'FINISHING',
  Reserved = 'RESERVED',
  Unavailable = 'UNAVAILABLE',
  Faulted = 'FAULTED',
}
